/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  notificationSetting,
  notificationType,
  showNotification,
} from "../Common";
import { connectWallet } from "../Scripts/interact";
import useWalletChange from "../hooks/useWalletChange";

const UtilitiesHeader = () => {
  const { isWalletConnected, changedAddress } = useWalletChange();

  const connectWalletPressed = async () => {
    const response = await connectWallet();

    if (response.status) {
      console.log("Wallet Connected");
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  return (
    <>
      <div className="banner-sec uti-header">
        <div className="container">
            <h1>Super creators website <br/>utility and baby area</h1>
        </div>
      </div>
    </>
  );
};

export default UtilitiesHeader;
